<template>
  <div>
    <div class="columns is-gapless">
      <div class="column">
        <div class="field">
          <div class="field is-horizontal">
            <div class="field-body">
              <div class="field-body">
                <div class="field has-addons">
                  <div class="control has-icons-left has-icons-right">
                    <input class="input"
                      v-model="filter.query"
                      type="text"
                      placeholder="Start typing to filter"
                      @input="search">
                    <span class="icon is-left">
                      <i class="mdi mdi-magnify mdi-18px" />
                    </span>
                  </div>
                  <div class="control">
                    <a class="button is-primary is-outlined tooltip"
                      data-tooltip="Reset search"
                      @click="reset()">
                      <span class="icon">
                        <i class="mdi mdi-close mdi-24px" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <div class="control is-pulled-right">
            <div class="select"
              @change="getAvailableMiscs()">
              <select v-model="activeTab">
                <option :value="labourType.toUpperCase() === availableMiscTypes.emta.toUpperCase() ? availableMiscTypes.emta : availableMiscTypes.standard">Standard</option>
                <option :value="availableMiscTypes.custom">Custom</option>
                <option :value="availableMiscTypes.emtasundry">e-MTA Sundry</option>
                <option v-if="$userInfo && $userInfo.countryCode.localeCompare('NZ', $userInfo.locale, {sensitivity: 'accent'}) === 0"
                  :value="availableMiscTypes.veronz">Vero-NZ</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
      :columns="columns"
      :page-index="filter.pageIndex"
      :page-size="filter.pageSize"
      :total-rows="totalRows"
      :is-loading="isTableLoading"
      :sort-column="filter.sortColumn"
      :sort-order="filter.sortOrder"
      @pageChanged="onPageChange"
      @sort="sort">
      <tr v-for="(item, index) in availableItems"
        :key="index"
        @dblclick="addNewItem(item, index)"
        :class="{ 'is-selected' : selectedRow === index }"
        @click="highlightSelected(index, $event)">
        <td>{{ item.itemNo }}</td>
        <td>{{ item.description }}</td>
        <td class="has-text-right">{{ $filters.formatNumber(item.price, $userInfo.locale) }}</td>
        <td class="has-vertical-middle has-text-centered is-content-width">
          <a class="button is-primary is-small is-inverted"
            @click="addNewItem(item, index)">
            <span class="icon is-medium">
              <i class="mdi mdi-plus mdi-24px" />
            </span>
          </a>
        </td>
      </tr>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <span icon="icon is-large">
              <i class="mdi mdi-48px mdi-emoticon-sad" />
            </span>
            <p>Nothing</p>
          </div>
        </section>
      </template>
    </bulma-table>
  </div>
</template>

<script>
import QuoteService from '@/views/quote/QuoteService'
import { AvailableMiscTypes } from '@/views/quote/QuoteService'
import { AvailableMiscColumns } from '@/views/quote/columns'
import { ItemCategoryTypes, LabourTimeTypes } from '@/enums'
import BulmaTable from '@/components/BulmaTable'
import _debounce from 'lodash.debounce'
import Guid from '@/components/Guid'
import { QuoteItemModel } from '@/classes/viewmodels'

export default {
  name: 'QuoteTemplateAvailableMiscs',
  components: {
    BulmaTable
  },
  props: {
    value: {
      type: Array,
      default: function() {
        return []
      }
    },
    quoteId: {
      type: String,
      default: ''
    },
    labourType: {
      type: String,
      default: ''
    },
    nextLineNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
      innerValue: null,
      selectedRow: null,
      isTableLoading: false,
      totalRows: 0,
      filter: {
        countryId: Guid.empty(),
        query: '',
        type: 'standard',
        sortColumn: '',
        sortOrder: '',
        pageIndex: 1,
        pageSize: this.pageSize
      },
      availableItems: null,
      selectedItems: [],
      activeTab: '',
      preActiveTab: ''
    }
  },
  computed: {
    columns() {
      return AvailableMiscColumns
    },
    newItems() {
      return this.value.filter(i => i.isNew && !i.deleted)
    },
    availableMiscTypes() {
      return AvailableMiscTypes
    }
  },
  created() {
    this.activeTab = this.labourType === LabourTimeTypes.eMTA ? this.availableMiscTypes.emta : this.availableMiscTypes.standard
    this.innerValue = this.value
    this.getAvailableMiscs()
  },
  mounted() {},
  methods: {
    async getAvailableMiscs() {
      this.isTableLoading = true

      if (this.activeTab === AvailableMiscTypes.custom)
      {
        this.filter.type = this.activeTab
      }

      if (this.activeTab === AvailableMiscTypes.standard)
      {
        this.filter.type = `${AvailableMiscTypes.standard}, ${AvailableMiscTypes.custom}`
      }

      if (this.preActiveTab !== this.activeTab)
      {
        this.filter.pageIndex = 1
        this.preActiveTab = this.activeTab
      }

      this.availableItems = await QuoteService.getAvailableMiscItems(this.filter, this.activeTab)
      this.totalRows = this.availableItems.length > 0 ? this.availableItems[0].totalRows : 0
      this.isTableLoading = false
    },
    highlightSelected(index, event) {
      this.selectedRow = index
    },
    onPageChange(pageIndex) {
      this.filter.pageIndex = pageIndex
      this.getAvailableMiscs()
    },
    sort(name, order) {},
    reset() {
      this.selectedItems = []
      this.filter.query = ''
      this.type = 'standard'
      this.filter.pageIndex = 1
      this.getAvailableMiscs()
    },
    search: _debounce(function() {
      this.filter.pageIndex = 1
      this.getAvailableMiscs()
    }, 500),
    cancel(value) {
      this.selectedItems = value
    },
    addNewItem(item, index) {
      const existingItem = this.value.find(i => i.itemDesc === item.description && i.itemNo === item.itemNo && !i.deleted && !i.deleteOtherItem)
      if (!existingItem) {
        let newItem = new QuoteItemModel(this.quoteId, item.itemNo, item.description, ItemCategoryTypes.MISC)
        newItem.lineNumber = this.nextLineNumber
        newItem.value = item.price
        newItem.side = item.side
        newItem.sortNo = this.value.length ? Math.max(...this.value.map(i => i.sortNo)) + 1 : 1
        this.$emit('item-added', newItem)
      } else {
        this.$notification.openNotificationWithType('warning', 'Misc', 'Item is already in selected list. Item not added.')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.svg path {
  fill: red !important;
  &:hover path {
    fill: white !important;
  }
}
</style>
